import { render, staticRenderFns } from "./shuping.vue?vue&type=template&id=2235d928"
import script from "./shuping.vue?vue&type=script&lang=js"
export * from "./shuping.vue?vue&type=script&lang=js"
import style0 from "./shuping.vue?vue&type=style&index=0&id=2235d928&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports